import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import WIDGET_DEFINITIONS from './widgetDefinitions';

const WidgetPalette = ({ widgetConfig, onToggleWidget, onClose }) => {
  return (
    <div className="so-palette-inline-panel">
      <div className="so-palette-header">
        <h3>Toggle Widgets</h3>
        <button className="so-palette-close" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
      <div className="so-palette-list">
        {WIDGET_DEFINITIONS.map(def => {
          const cfg = widgetConfig.find(w => w.id === def.id);
          const isVisible = cfg ? cfg.visible : true;
          return (
            <button
              key={def.id}
              className={`so-palette-item ${isVisible ? 'so-palette-item-active' : 'so-palette-item-hidden'}`}
              onClick={() => onToggleWidget(def.id)}
            >
              <FontAwesomeIcon icon={def.icon} className="so-palette-item-icon" />
              <span className="so-palette-item-label">{def.label}</span>
              <FontAwesomeIcon
                icon={isVisible ? faEye : faEyeSlash}
                className="so-palette-item-toggle"
              />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default WidgetPalette;
